<template>
    <v-app>
      <dashboard-core-app-bar />

      <dashboard-core-drawer />

      <dashboard-core-view class="before-content" />


      <!-- <dashboard-core-settings /> -->
    </v-app>
</template>

<script>
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      DashboardCoreSettings: () => import('./components/core/Settings'),
      DashboardCoreView: () => import('./components/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),
  }
</script>

<style >
.before-content:before{
  background-color: #1b2f46;
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 215px;

}

      /* background-image: linear-gradient(
45deg
,#cc2b5e,#753a88)!important;
    background-repeat: repeat-x!important;
    opacity: .9; */
</style>
